import * as React from 'react';

import { Button, CardV2, Col, Row } from '@coursera/coursera-ui';

import SearchCarouselCard from 'bundles/career-plans/components/degree/SearchCarouselCard';
import TrackedDiv from 'bundles/page/components/TrackedDiv';

import _t from 'i18n!nls/career-plans';

import 'css!./__styles__/DegreeBanner';

type Props = {
  degrees: Array<any>;
  seeMoreDegreesUrl?: string;
};

const DegreeBanner = ({ degrees, seeMoreDegreesUrl }: Props) => {
  if (!degrees?.length) return null;

  return (
    <Row>
      <Col className="careerPlans-degrees careerPlans-blue-bg">
        <TrackedDiv
          className="careerPlans-container"
          trackingName="careerplans_degree_banner"
          data-e2e="CareerPlansDegreeBanner"
        >
          <section className="rc-CareerPlansDegreeBanner">
            <div className="careerPlansDegreeBanner-container">
              <div className="careerPlansDegreeBanner-container--text">
                <h2 className="careerPlansDegreeBanner-subHeader careerPlans-sectionHeader">{_t('Online Degrees')}</h2>
                <h3 className="careerPlansDegreeBanner-header careerPlans-header">
                  {_t("Transform your resume with a Master's degree")}
                </h3>
                <p className="careerPlansDegreeBanner-text careerPlans-text">
                  {_t(
                    'Explore top-quality degrees that you can complete at your pace from a world-class university. Many degrees have courses or Specializations you can start today. After you are accepted to the program, the material you complete will count toward your degree coursework.'
                  )}
                </p>
                {seeMoreDegreesUrl && (
                  <Button
                    data-track={true}
                    type="primary"
                    label={_t('Learn More')}
                    htmlAttributes={{ href: seeMoreDegreesUrl }}
                    data-e2e="CareerPlansDegreeBanner-seemore"
                  />
                )}
              </div>
              <div className="careerPlansDegreeBanner-container--degrees">
                {degrees.map((productHit, index) => (
                  <div key={`careerPlansDegreeBanner-${productHit.name}`}>
                    <CardV2
                      style={{ backgroundColor: 'var(--cds-color-neutral-background-primary)' }}
                      rootClassName="careerPlansDegreeBanner-cardV2"
                    >
                      <SearchCarouselCard
                        productHit={productHit}
                        productPosition={index + 1}
                        trackingName="degree_carousel_card"
                        data-e2e="CareerPlansDegreeBanner-degree"
                        disableMaxHeight
                      />
                    </CardV2>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </TrackedDiv>
      </Col>
    </Row>
  );
};

export default DegreeBanner;
